import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";
const columnStyle = {
  color: "#000000",
  align: "right",
  fontWeight: 500,
  minWidth: 170,
  maxWidth: 170,
  fontSize: "14px",
  fontFamily: "Montserrat",
  backgroundColor: "#fff",
};

const textStyle = {
  fontWeight: 500,
  fontSize: "13px",
  fontFamily: "Montserrat",
};

const captionStyle = {
  background: "#004990",
  color: "#FFF",
  borderRadius: "10px",
  fontFamily: "Montserrat",
};

const columns = [
  { id: "name", label: "Negocios" },
  { id: "order", label: "Orden" },
  {
    id: "date",
    label: "Fecha",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "hour",
    label: "Hora",
  },
  {
    id: "formpayment",
    label: "Forma de pago",
  },
  {
    id: "import",
    label: "Importe de venta",
  },
  {
    id: "discountcl",
    label: "Descuento de cliente",
  },
  {
    id: "discountsincl",
    label: "Importe de venta sin descuento",
  },
  {
    id: "comisionclient",
    label: "Comisión de envio",
  },
  {
    id: "importventplus",
    label: "Importe de venta + envio del cliente",
  },
  {
    id: "tarifService",
    label: "Tarifa de servicio",
  },
  {
    id: "mcc",
    label: "Monedero",
  },
  {
    id: "subtotal",
    label: "Sub Total",
  },
  {
    id: "comisionnk",
    label: "Comisión de NIku",
  },
  {
    id: "subnullIva",
    label: "Subtotal sin IVAu",
  },
  {
    id: "iva8",
    label: "IVA(8%)",
  },
  {
    id: "isr",
    label: "ISR(1%)",
  },
  {
    id: "sendShop",
    label: "Comisión de envio por tienda",
  },
  {
    id: "propine",
    label: "Propina",
  },
  {
    id: "delivery",
    label: "Repartidor",
  },
  {
    id: "dispersion",
    label: "Total a depositar por orden",
  },
  {
    id: "domiciliacion",
    label: "Total a cobrar por orden",
  },
  //{ id: "total", label: "Total", format: (value) => value.toFixed(2) },
];
var fecha = "";
export default function CommissionByShopTable({ businessName, data }) {
  useEffect(() => {
    var date = new Date();
    fecha = date.toDateString();
  }, []);
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 700 }}>
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{ fontFamily: "Montserrat" }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} sx={columnStyle}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  <TableCell key={"name"} align={"left"} sx={textStyle}>
                    {businessName}
                  </TableCell>

                  <TableCell key={"order"} align={"left"} sx={textStyle}>
                    {row.id}
                  </TableCell>

                  <TableCell key={"date"} align={"left"} sx={textStyle}>
                    {row.creacion}
                  </TableCell>

                  <TableCell key={"hour"} align={"left"} sx={textStyle}>
                    {row.Hora}
                  </TableCell>
                  <TableCell key={"formpayment"} align={"left"} sx={textStyle}>
                    {row.Formadepago}
                  </TableCell>
                  <TableCell key={"import"} align={"left"} sx={textStyle}>
                    ${row.Importventa}
                  </TableCell>
                  <TableCell key={"discountcl"} align={"left"} sx={textStyle}>
                    ${row.Descuentocl}
                  </TableCell>
                  <TableCell
                    key={"discountsincl"}
                    align={"left"}
                    sx={textStyle}
                  >
                    ${row.importsindiscount}
                  </TableCell>
                  <TableCell
                    key={"comisionclient"}
                    align={"left"}
                    sx={textStyle}
                  >
                    ${row.ComsendCustomer}
                  </TableCell>
                  <TableCell
                    key={"importventplus"}
                    align={"left"}
                    sx={textStyle}
                  >
                    ${row.importpluscomcustomer}
                  </TableCell>
                  <TableCell key={"tarifService"} align={"left"} sx={textStyle}>
                    ${row.tarifeservice}
                  </TableCell>
                  <TableCell key={"mcc"} align={"left"} sx={textStyle}>
                    ${row.MCC}
                  </TableCell>
                  <TableCell key={"subtotal"} align={"left"} sx={textStyle}>
                    ${row.Subtotal}
                  </TableCell>
                  <TableCell key={"comisionnk"} align={"left"} sx={textStyle}>
                    ${row.ComisionNk}
                  </TableCell>
                  <TableCell key={"subnullIva"} align={"left"} sx={textStyle}>
                    ${row.Subsiniva}
                  </TableCell>
                  <TableCell key={"iva8"} align={"left"} sx={textStyle}>
                    ${row.IVA8}
                  </TableCell>
                  <TableCell key={"isr"} align={"left"} sx={textStyle}>
                    ${row.ISR1}
                  </TableCell>
                  <TableCell key={"sendShop"} align={"left"} sx={textStyle}>
                    ${row.Comsend}
                  </TableCell>
                  <TableCell key={"propine"} align={"left"} sx={textStyle}>
                    ${row.propine}
                  </TableCell>
                  <TableCell key={"delivery"} align={"left"} sx={textStyle}>
                    {row.deliveryman}
                  </TableCell>
                  <TableCell key={"dispersion"} align={"left"} sx={textStyle}>
                    ${row.TotalADepositarporOrden}
                  </TableCell>
                  <TableCell
                    key={"domiciliacion"}
                    align={"left"}
                    sx={textStyle}
                  >
                    ${row.Domicializacion}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <caption style={captionStyle}>{fecha}</caption>
        </Table>
      </TableContainer>
    </Paper>
  );
}
